<template>
  <div class="prove">
    <topmytitle :title1="titlework" />
    <section class="provetop">
      <section class="provesec"
               @click="gotoEmployment">
        <div>
          <img src="../assets/obj(6).png"
               alt="" />
          <span>在职证明</span>
        </div>
        <van-icon class="arrow"
                  name="arrow" />
      </section>
      <section class="provesec"
               @click="gotoIncome"
               style="border-top: 1px solid #e5e5e5">
        <div>
          <img src="../assets/obj(7).png"
               alt="" />
          <span>收入证明</span>
        </div>
        <van-icon class="arrow"
                  name="arrow" />
      </section>
      <section class="provesec"
               @click="gotoResidence"
               style="border-top: 1px solid #e5e5e5">
        <div>
          <img src="../assets/obj(6).png"
               alt="" />
          <span>居住证明</span>
        </div>
        <van-icon class="arrow"
                  name="arrow" />
      </section>
      <section class="provesec"
               style="border-top: 1px solid #e5e5e5"
               @click="gotoRecord">
        <div>
          <van-icon name="comment-o" />
          <span>证明记录</span>
        </div>
        <van-icon class="arrow"
                  name="arrow" />
      </section>
    </section>
    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
import topmytitle from '../components/topmytitle'
import LoadingShow from '../components/loading'
export default {
  name: 'prove',
  data() {
    return {
      titlework: '证明开具',
      loading: false,
    }
  },
  methods: {
    gotoEmployment() {
      this.$router.push('/employment')
    },
    gotoIncome() {
      this.$router.push('/income')
    },
    gotoResidence() {
      this.$router.push('/residence')
    },
    gotoRecord() {
      this.$router.push('/prorecord')
    },
  },
  components: {
    topmytitle,
    LoadingShow,
  },
}
</script>

<style lang="less" scoped>
.provetop {
  background: white;
  margin: 10px 0px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  .provesec {
    margin-left: 20px;
    display: flex;
    line-height: 44px;
    div {
      img {
        height: 15px;
        width: 15px;
        margin-right: 10px;
      }
      i {
        margin-right: 9px;
        font-size: 17px;
      }
    }
    .arrow {
      flex: 1;
      text-align: right;
      margin-right: 20px;
      line-height: 44px;
      color: #c4c4c6;
    }
  }
}
</style>

